/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type consents_ParentConsentItem = {
    consent_id?: string | null;
    granted_by_contact_id?: string | null;
    scope: consents_ParentConsentItem.scope;
    state: consents_ParentConsentItem.state;
    valid_from?: string | null;
};
export namespace consents_ParentConsentItem {
    export enum scope {
        DOCUMENTATION = 'documentation',
        PHOTO_INTERNAL = 'photo_internal',
        PHOTO_PARENT_VISIBLE = 'photo_parent_visible',
        PRINTED_PORTFOLIO = 'printed_portfolio',
        EXTERNAL_SHARING = 'external_sharing',
    }
    export enum state {
        GRANTED = 'granted',
        REFUSED = 'refused',
        UNKNOWN = 'unknown',
    }
}

